export default {
  tooltipXDateFormat: 'ymd'
};
